import { DELIVERY_DISCOUNT_CATEGORY_DESCRIPTIONS } from '@nandosaus/constants';

import { Link } from '../../link';
import { navigation } from '../../../constants';

const DeliveryDiscountCategoryDescription = () => {
  return (
    <>
      {`${DELIVERY_DISCOUNT_CATEGORY_DESCRIPTIONS.COKE} Check the `}
      <Link target="_blank" variant={3} href={navigation.TERMS_CONDITIONS}>
        terms and conditions
      </Link>
      .
    </>
  );
};

export { DeliveryDiscountCategoryDescription };
